<div
  class="ui vertical basic segment"
  [ngClass]="{ loading: pendingArr?.length }"
  appMargin="0"
  appPadding="0"
  style="padding-bottom: 2rem"
>
  <div class="wrapper">
    <div class="ui success message">
      <p>Requirements to proceed with the update:</p>
      <div class="flex" *ngIf="affiliateTypeId === 'shareholder_type'">
        <img
          [src]="
            !checkDisabled()
              ? 'assets/icons/checked.svg'
              : 'assets/icons/x-mark-red.svg'
          "
          alt="check"
        />
        <span>
          The total shareholding percentage must be at least 99% or exactly 100%
          <span class="current-value">
            Current total shareholding percentage:
            {{ returnTotalShareholding() }}%</span
          >
        </span>
      </div>
      <div class="flex">
        <img
          [src]="
            !uploadSupportingFilesInvalid()
              ? 'assets/icons/checked.svg'
              : 'assets/icons/x-mark-red.svg'
          "
          alt="x-mark"
        />
        <span
          >Ensure all mandatory documents are uploaded to avoid errors during
          the update process.</span
        >
      </div>
      <div class="flex">
        <img
          [src]="
            !checkIfStructureChanged()
              ? 'assets/icons/checked.svg'
              : 'assets/icons/x-mark-red.svg'
          "
          alt="x-mark"
        />
        <span>
          There must be at least one change made to the
          {{ affiliateTypeName }} structure to proceed with the update.
        </span>
      </div>
    </div>
    <div class="refresh_button" *ngIf="existing">
      <div
        style="
          padding: 11px 16px;
          border-radius: 8px;
          border: 1px solid #d82c0d;
          height: 36px;
          background-color: #ffffff;
          position: relative;
        "
      >
        <button
          (click)="startAfresh.emit()"
          style="
            color: #d82c0d;
            border: none;
            gap: 12px;
            display: flex;
            align-items: center;
            margin-top: -3px;
            cursor: pointer;
            background-color: #ffffff;
          "
        >
          <img [src]="'assets/icons/x-mark-red.svg'" alt="check" />
          Start Afresh
        </button>
      </div>
    </div>
    <div
      class="containerNew"
      *ngFor="let director of companyDirectors; let i = index"
    >
      <div class="contents">
        <div class="image">
          <img
            *ngIf="director.photographDocumentPath"
            src="{{ baseUrl }}/public/image/?media={{
              director?.photographDocumentPath
            }}"
          />
          <img
            *ngIf="!director.photographDocumentPath"
            src="assets/avatar/1.jpg"
          />
        </div>
        <div class="content_name">
          <div class="tag" *ngIf="affiliateTypeId === 'shareholder_type'">
            {{
              director?.companyName && director?.companyRegNumber
                ? "Company"
                : "Individual"
            }}
          </div>
          <div class="name">
            <h2>{{ director?.firstName }} {{ director?.lastName }}</h2>
          </div>
          <div
            class="information"
            [ngClass]="{
              gap16: affiliateTypeId === 'shareholder_type' && !usePercentage,
              gap32:
                affiliateTypeId !== 'shareholder_type' ||
                (affiliateTypeId === 'shareholder_type' && usePercentage)
            }"
          >
            <div
              class="info"
              style="width: 120px"
              *ngIf="affiliateTypeId === 'shareholder_type' && !usePercentage"
            >
              <p>Shares Allocated</p>
              <h4>
                {{
                  (director?.shareholding / 100) * shareholdingAmount
                    | number: "1.0-0"
                }}
              </h4>
            </div>
            <div
              class="info"
              style="width: 120px"
              *ngIf="affiliateTypeId === 'shareholder_type'"
            >
              <p>Share Capital Percentage</p>
              <h4>{{ director?.shareholding.toFixed(2) }}%</h4>
            </div>
            <div
              class="info"
              [ngClass]="{
                width150: affiliateTypeId !== 'shareholder_type',
                widthFit: affiliateTypeId === 'shareholder_type'
              }"
              *ngIf="director.organizationOwnershipId"
            >
              <p>Date Verified</p>
              <h4>{{ director?.dateCreated | date: "d MMM, y h:mm a" }}</h4>
            </div>
            <div
              class="info"
              [ngClass]="{
                width150:
                  affiliateTypeId === 'shareholder_type' && !usePercentage,
                widthFit:
                  affiliateTypeId === 'shareholder_type' && usePercentage,
                width250: affiliateTypeId !== 'shareholder_type'
              }"
            >
              <p>Added By</p>
              <h4>{{ director?.createdBy | createdBy }}</h4>
            </div>
            <div class="info" style="width: fit-content">
              <p>Status</p>
              <div class="pills">
                <esl-pills
                  [color]="getColorForLabel(director?.actionType)"
                  [textColor]="getColorTextForLabel(director?.actionType)"
                  label="{{
                    director?.actionType === 'NONE' || !director?.actionType
                      ? 'NOT CHANGED'
                      : director?.actionType
                  }}"
                ></esl-pills>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="action_button">
        <img
          src="assets/icons/editIcon.svg"
          (click)="edit(director, i)"
          alt=""
        />
        <img
          src="assets/icons/deleteIcon.svg"
          alt=""
          (click)="deleteIndividual(director, i)"
        />
      </div>
    </div>
    <div
      *ngIf="companyDirectors && companyDirectors.length < 1"
      style="width: 100%; margin: 0 auto"
      class="no-record"
    >
      <h3
        style="
          font-size: 16px;
          font-weight: 700;
          margin-top: 2.5rem;
          text-align: center;
        "
      >
        This Section has no Record
      </h3>
      <p
        style="
          font-size: 12px;
          font-weight: 400;
          margin-top: 16px;
          text-align: center;
        "
      >
        Click on the Add invidual to make Updates
      </p>
    </div>
    <div class="supporting_document" *ngIf="uploads?.length > 0">
      <div class="linked_notreal">UPDATE MODE</div>
      <h2>Uploaded Supporting Documents</h2>
      <p>
        Click the plus (+) button to upload new document. You can link any
        similar document you have uploaded before now by choosing the Link
        option. Only .pdf, .doc and .ppt files can be uploaded
      </p>
    </div>
    <div
      class="upload_document"
      *ngFor="let document of documentss; let i = index"
    >
      <div class="upload_document_header">
        <h2>
          Upload {{ document.documentTypeName }}
          <span *ngIf="document.isRequired" style="color: red">*</span>
        </h2>
        <div class="flex">
          <div class="pills" *ngIf="document.isRequired">
            <esl-pills
              color="#E4E5E7"
              textColor="#505050"
              label="MANDATORY"
            ></esl-pills>
          </div>
          <div suiDropdown>
            <button
              class="ui tiny icon button"
              style="border: none !important; align-items: center !important"
              style="float: right"
            >
              <img
                src="assets/icons/extra-actions.svg"
                suiPopup
                [popupInverted]="true"
                popupPlacement="bottom"
                popupText="upload Document"
                alt=""
              />
            </button>
            <div
              class="menu"
              style="
                height: 80px;
                margin-top: 40px;
                position: absolute;
                width: 100px;
                right: 0px;
                width: fit-content;
              "
              suiDropdownMenu
              appPadding
              paddingX="3"
            >
              <div
                class="item"
                style="
                  font-family: 'Roboto';
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 14.06px;
                  text-align: left;
                  color: #505050;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  height: 40px;
                  cursor: pointer;
                "
                (click)="uploader.click()"
              >
                <input
                  #uploadDoc
                  type="file"
                  accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
                  #uploader
                  multiple
                  (change)="onFileChanges($event, document)"
                  placeholder="Browse for documents"
                  onclick="value = null"
                  style="display: none"
                />
                Upload new document
              </div>
              <a
                class="item"
                style="
                  font-family: 'Roboto';
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 14.06px;
                  text-align: left;
                  color: #505050;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  height: 40px;
                  cursor: pointer;
                "
                (click)="LinkDocument.emit(document.documentTypeName)"
                >Link an existing document</a
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="upload_document_content"
        *ngIf="
          returnDocumentType(
            allLinkedDocuments,
            document.documentTypeName,
            document.documentTypeId
          ).length === 0 &&
          document.uploadedFiles &&
          document.uploadedFiles.length === 0
        "
      >
        <p>No Document uploaded</p>
      </div>
      <div>
        <div
          class="more_information"
          *ngIf="document.uploadedFiles && document.uploadedFiles.length > 0"
        >
          <h4 class="class">{{ document.documentTypeName }}</h4>
          <div class="linked_not">UPLOADED</div>
        </div>
        <div
          class="added_document"
          *ngFor="let file of document.uploadedFiles; let fileIndex = index"
        >
          <div class="contents">
            <div class="image">
              <img src="assets/icons/Frame.svg" alt="" />
            </div>
            <div class="content_name">
              <h5>
                {{ file.name }}
              </h5>
            </div>
          </div>
          <div class="action_button">
            <img
              src="assets/icons/Frame 5492.svg"
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="View"
              (click)="viewFiles(file)"
              alt=""
            />
            <img
              src="assets/icons/trash.svg"
              (click)="removeFile(document, fileIndex)"
              alt=""
            />
          </div>
        </div>
      </div>

      <div
        class="linked_document_container"
        *ngIf="
          returnDocumentType(
            allLinkedDocuments,
            document.documentTypeName,
            document.documentTypeId
          ).length > 0
        "
      >
        <div class="more_information">
          <h4 class="class">{{ document.documentTypeName }}</h4>
          <div class="linked_not">LINKED</div>
        </div>
        <div
          class="linked_document"
          *ngFor="
            let doc of returnDocumentType(
              allLinkedDocuments,
              document.documentTypeName,
              document.documentTypeId
            );
            let i = index
          "
        >
          <div class="contents">
            <div class="content_name">
              <div class="name">
                <img src="assets/icons/document-text.svg" alt="" />
                <h5>
                  {{ doc.documentName }}
                </h5>
              </div>
              <p class="paragraph">ADDED BY:</p>
              <div class="information">
                <div class="info">
                  <div class="flex">
                    <h4>
                      <img src="assets/icons/User.svg" alt="" />{{
                        doc.createdBy | createdBy
                      }}
                    </h4>
                    <h4>
                      <img src="assets/icons/Clock 2.svg" alt="" />
                      {{ doc.dateCreated | date: "d MMM, y h:mm a" }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="action_button">
            <img
              src="assets/icons/Frame 5492.svg"
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="View"
              (click)="viewDocument(doc)"
              alt=""
            />
            <img
              src="assets/icons/trash.svg"
              (click)="removeLinkedDocument(doc, i)"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
